import { render, staticRenderFns } from "./EmploymentCard.vue?vue&type=template&id=53ce3d58&scoped=true&"
import script from "./EmploymentCard.vue?vue&type=script&lang=ts&"
export * from "./EmploymentCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ce3d58",
  null
  
)

export default component.exports